/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_CodeInputs */

const vi_tea_purchase_code = /** @type {(inputs: Tea_Purchase_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã đơn`)
};

/**

* @param {Tea_Purchase_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_code = /** @type {((inputs?: Tea_Purchase_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_code(inputs)
});